import React, { useState, useEffect } from "react";
import ConfirmDialog from "../../../components/actionDialogs/confirmDialog";
import CustomTable from "../../../components/table/table";
import "./view.css";
import { admin_market_analysis_delete, get_market_analysis_list } from "../admin.api";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import jwtDecode from "jwt-decode";
import AddMarketAnalysis from "./add";
import EditMarketAnalysis from "./edit";
import ViewMarketAnalysis from "./view";

export default function View(props) {
  const [data, setData] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [openAction, setOpenAction] = useState(false);
  const [activeData, setActiveData] = useState({});
  const [addNew, setAddNew] = useState(false);
  const [edit, setEdit] = useState(false);
  const [editData, setEditData] = useState({});
  const [view, setView] = useState(false);
  const [viewData, setViewData] = useState({});
  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const handleMarketAnalysisList = async () => {
    setIsActive(true);
    try {
      const res = await get_market_analysis_list();
      const tdata = Array.isArray(res)
        ? res.map((item, index) => ({
          ...item,
          slno: index + 1,
        }))
        : [];

      setData(tdata);
    } catch (error) {
      setData([]);
      setSnackMessage(error?.response?.data?.message || error?.message || "Failed to fetch market analysis list");
      setIsSnackError(true);
      setSnackOpen(true);
    } finally {
      setIsActive(false);
    }
  };

  useEffect(() => {
    handleMarketAnalysisList();
  }, []);

  useEffect(() => {
    return () => {
      setData([]);
    };
  }, []);

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      handleMarketAnalysisList();
    }
  };

  const handleAddNew = () => {
    setAddNew(true);
  };

  const handleClose = () => {
    setAddNew(false);
    setEdit(false);
    setEditData({});
    setView(false);
    setViewData({});
    handleMarketAnalysisList();
  };

  const handleView = (row) => {
    setViewData(row);
    setView(true);
  };

  const handleEdit = (row) => {
    setEditData(row);
    setEdit(true);
  };

  const handleDelete = (row) => {
    setActiveData(row);
    setOpenAction(true);
  };

  const handleCancelDelete = () => {
    setOpenAction(false);
  };

  const handleDeleteConfirm = (row) => {
    setOpenAction(false);
    setIsActive(true);
    admin_market_analysis_delete(row.id)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
      })
      .catch((error) => {
        setSnackMessage(error?.response?.data?.message || error?.message || "Delete failed");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };

  return (
    <div>
      <Loader open={isActive} />
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <div className="view-container">
        <h6>
          <b>Market Analysis</b>
        </h6>
        <hr />
        {adminType === 1 && (
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={(e) => handleAddNew(e)}
          >
            Add New
          </button>
        )}
        <CustomTable
          {...props}
          columns={[
            // { title: "Sl No", field: "slno" },
            { title: "Opportunity", field: "opportunity" },
          ]}
          data={data}
          actions={
            adminType === 1
              ? [
                { type: "view", handleClick: handleView },
                { type: "edit", handleClick: handleEdit },
              ]
              : [
                { type: "view", handleClick: handleView },
                { type: "delete", handleClick: handleDelete }
              ]
          }
        />
      </div>
      {openAction && (
        <ConfirmDialog
          open={openAction}
          title="Delete Market Analysis ?"
          data={activeData}
          message="Are you sure to delete this Market Analysis?"
          secondary_action="Cancel"
          primary_action="Delete"
          handleClose={handleCancelDelete}
          handleConfirm={handleDeleteConfirm}
        />
      )}
      {addNew && (
        <AddMarketAnalysis
          open={addNew}
          handleClose={handleClose}
          {...props}
        />
      )}
      {edit && (
        <EditMarketAnalysis
          open={edit}
          handleClose={handleClose}
          editData={editData}
          {...props}
        />
      )}
      {view && (
        <ViewMarketAnalysis
          open={view}
          handleClose={handleClose}
          viewData={viewData}
          {...props}
        />
      )}
    </div>
  );
}
